export var Events;
(function (Events) {
    class EventEmitter {
        listeners = {};
        addEventListener(eventName, fn) {
            const listeners = (this.listeners[eventName] || []);
            if (fn == null || typeof fn !== 'function') {
                console.warn('Event listener is not a function');
            }
            this.listeners[eventName] = listeners.concat(fn);
        }
        removeEventListener(eventName, fn) {
            const listeners = (this.listeners[eventName] || []);
            this.listeners[eventName] = listeners.filter(f => f !== fn);
        }
        emit(eventName, event) {
            const listeners = (this.listeners[eventName] || []);
            listeners.forEach(fn => fn && fn(event));
        }
    }
    Events.EventEmitter = EventEmitter;
})(Events || (Events = {}));
//# sourceMappingURL=events.js.map